import React, { useState, useEffect } from "react";
import {
  TextField,
  InputAdornment,
  IconButton,
  FormHelperText,
  Grid,
  Link,
  Typography,
} from "@material-ui/core";
import { Search } from "@material-ui/icons";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  iconHeight: {
    height: "10% !important",
  },
  iconStyle: {
    padding: "0.3rem 0.3rem 0.3rem 0.5rem !important",
  },
  widthSearch: {
    width: "18vw",
  },
  fullwidthSearch: {
    width: "98%",
    marginLeft: "1%",
  },
  errorborder: {
    border: "1px solid " + theme.palette.eDanger.dark,
  },
  space: {
    padding: "0rem 0.25rem 0.25rem 0.25rem",
  },
  errorColor: {
    color: theme.palette.eDanger.dark,
    marginTop: "0px",
    [theme.breakpoints.between("md", "xl")]: {
      marginBottom: "1%",
    },
  },
  linkColor: {
    color: theme.palette.ePrimary.base + "!important",
    cursor: "pointer",
    textDecoration: "underline !important",
    "&:hover": {
      color: theme.palette.ePrimary.hover + "!important",
    },
  },
  resultStyle:{
    color:theme.palette.ePrimary.base +"!important",
  },
  spacePadding:{
    padding:"0.6rem"
  },
  positionSearch:{
    position:"absolute",
    right:20,
    textAlign:"end",
    top:"65px",
    [theme.breakpoints.down("xs")]: {
      position:"relative !important",
      top:0
    },
  }
}));

export const SearchBarTextField = withStyles({
  root: {
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderRadius: "50px !important",
      },
    },
    "& .MuiOutlinedInput-input": {
      padding: "10px 7px",
    },
  },
})(TextField);
function SearchBar({ callSearchApi, totalSearch, getDefaultSearch }) {
  const classes = useStyles();
  const [keyword, setKeyword] = useState("");
  const [error, setError] = useState(false);

   // let labels = useSelector(
  //   (state) => state?.labels?.data?.getLabels?.E_AUTH_LOGIN
  // );
const {t:labels ,ready:labelsReady}=useTranslation("label-E_AUTH_LOGIN")

  const handleSearchInputChange = (e) => {
    if(e.target.value.trim().length>0){
      setKeyword(e.target.value);
      setError(false);
    }
    else{
      callClearFunction()
    }
  };

  const searchClickHandle = (e) => {
    e.preventDefault();
    let word = keyword?.split("");
    if (word?.length >= 3) {
      callSearchApi(keyword);
      setError(false);
    } else {
      setError(true);
    }
  };
  const keyPress = (e) => {
    e.preventDefault();
    if (e.key === "Enter") {
      searchClickHandle();
    }
  };

  const callClearFunction = () => {
    setKeyword("");
    setError(false);
    getDefaultSearch();
  };

  return (
    <form>
      <SearchBarTextField
        style={{ width: "100%" }}
        variant="outlined"
        onChange={(e) => handleSearchInputChange(e)}
        value={keyword}
        placeholder={labels("E_AUTH_CONTENTS_SECTION_SEARCHBAR_PLACEHOLDER")}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <IconButton
                type="submit"
                onClick={searchClickHandle}
                onKeyPress={keyPress}
                className={classes.iconStyle}
              >
                <Search className={classes.iconHeight} />
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
      <Grid container justify="space-between">
        <Grid item className={classes.space}>
          {error ? (
            <FormHelperText className={classes?.errorColor}>
              {labels("E_AUTH_SEARCH_ERROR")}
            </FormHelperText>
          ) : (
            <div className={classes.spacePadding}/>
          )}
        </Grid>
        <Grid item className={classes.positionSearch}>
          {totalSearch || keyword ? (
            <Link
              align="right"
              underline="always"
              onClick={callClearFunction}
              className={classes.linkColor}
            >
              {labels("E_SEARCH_RESULTS_CLEAR")}
            </Link>
          ) : null}
          <br/>
           <Typography variant="caption" className={classes.resultStyle}>
              {totalSearch ? totalSearch === 1
                ? totalSearch + " " + labels("E_SEARCH_SINGLE_RESULT_FOUND")
                : totalSearch + " " + labels("E_SEARCH_MULTIPLE_RESULTS_FOUND"):null}
            </Typography>
        </Grid>
      </Grid>
    </form>
  );
}
export default SearchBar;
